import styled from 'styled-components';
import { Base as NavbarButtonBase } from '../NavbarButton/styles';

export const Base = styled(NavbarButtonBase)`
	width: 40px;
`;

